// extracted by mini-css-extract-plugin
export default {"ItemStyles":"ProtectedCodeListItem_ItemStyles__xrqB+","CodeSpan":"ProtectedCodeListItem_CodeSpan__k7jml"};